import Axios from "axios"


export async function get_notice_list(props) {
    const branch_id = props['branch_id']
    const Set_noticeList = props['Set_noticeList']
    const isMounted = props['isMounted']

    const result = await Axios
                    .post("/notice/load", {
                        branch_id: branch_id
                    })
    const data = result['data']

    Set_noticeList(data['list'])

    if(isMounted) {
        isMounted.current++
    }
}